import { EDescriptionQualityReason } from 'partner360/entities/keyInitiatives'

import { DESCRIPTION_QUALITY_REASON_TRANSLATION_PREFIX } from '../../configs/translations'

export const normalizeDescriptionQualityReason = (reason: string): string =>
  reason.replace(/[^a-zA-Z0-9]+/g, '').toLowerCase()

export const getDescriptionQualityReasonTranslation = (
  reason: EDescriptionQualityReason,
  isShort = false
): string =>
  `${DESCRIPTION_QUALITY_REASON_TRANSLATION_PREFIX}${normalizeDescriptionQualityReason(reason)}${
    isShort ? '-short' : ''
  }`
